import {CSR} from "../../constants/csr";

export function fetchCsr(params) {
  return {
    type: CSR.FETCH_CSR.MAIN,
    params
  }
}

